import { widgetManager } from '../../src/widgetManager/index.js'
import BaseChannel from './base'

export default class CustomChannel extends BaseChannel {
  constructor(settings, { i18n, billingService, widgetContainer, genesysAudioService, texts, widgetIndex }) {
    super(settings, { i18n, billingService, widgetContainer, genesysAudioService, texts, widgetIndex })

    this.action = settings.action
    this.channelType = 'custom'

    this.billingService = billingService
    this.billed = false
    this.widgetIndex = widgetIndex
  }
  open(id) {
    this.triggerPublicEvent('action_custom_start', { channel: 'custom' })

    const selectedChannel = this.widgetContainer.settings.widgets[this.widgetIndex].channels.find((channel) => channel.id === id)
    let isFormio = false
    let formDefinition = null
    try {
      formDefinition = JSON.parse(selectedChannel.params.script)
      isFormio = formDefinition.components
    } catch (e) {
      isFormio = selectedChannel.params.form
    }

    setTimeout(() => {
      if (!isFormio) {
        this.triggerPublicEvent('widget_business_success', { state: widgetManager.getState(), confirmed: false })
      }
      this.action()
      widgetManager.closeWidget(isFormio)
      if (!isFormio) {
        widgetManager.setWidgetTab('trueengage.channel_picker')
      }
    }, 10)

    if (!this.billed) {
      this.billingService.addInteraction({
        interactionType: 'Custom',
        additionalInfo: {
          visitorId: this.widgetContainer.token,
        },
      })
      this.billed = true
    }
  }
}
